import axiosInstance from '../../axiosConfig';

export async function fetchTradingSymbols(search = '') {
    const params = {};
    if (search) {
        params.search = search;
    }

    const response = await axiosInstance.get('/api/trading-hub/symbols', {
        params,
    });

    const symbols = Array.isArray(response.data) ? response.data : [];
    return symbols.map(({ tradingsymbol, exchange, name, strike, instrumentType }) => ({
        symbol: tradingsymbol,
        exchange: exchange || '',
        name: name || '',
        strike: strike,
        instrumentType: instrumentType || '',
    }));
}

export async function fetchInstrumentDetails(symbol) {
    if (!symbol) {
        throw new Error('Symbol is required');
    }

    const response = await axiosInstance.get(`/api/trading-hub/instruments/${encodeURIComponent(symbol)}`);
    return response.data;
}

export async function fetchInstrumentQuote(exchange, tradingsymbol) {
    if (!exchange || !tradingsymbol) {
        throw new Error('Exchange and tradingsymbol are required');
    }

    const response = await axiosInstance.get('/api/trading-hub/quote', {
        params: {
            exchange,
            tradingsymbol,
        },
    });

    return response.data;
}

export async function fetchTradingAccounts() {
    const response = await axiosInstance.get('/api/trading-hub/accounts');
    const accounts = Array.isArray(response.data) ? response.data : [];
    return accounts.map(({ accountId, alias, clientId, broker }) => ({
        accountId,
        alias: alias || '',
        clientId: clientId || '',
        broker: broker || '',
    }));
}

export async function fetchOrderMargins(payload) {
    const response = await axiosInstance.post('/api/trading-hub/order-margins', payload);
    return response.data;
}

export async function fetchAccountOrders() {
    const response = await axiosInstance.get('/api/trading-hub/orders');
    return response.data;
}

export async function submitTradingOrders(payload) {
    const response = await axiosInstance.post('/api/trading-hub/orders', payload);
    return response.data;
}

export async function submitGTTOrders(payload) {
    const response = await axiosInstance.post('/api/trading-hub/gtt', payload);
    return response.data;
}

export async function cancelTradingOrder({ accountId, orderId, variety, parentOrderId }) {
    const response = await axiosInstance.post('/api/trading-hub/orders/cancel', {
        accountId,
        orderId,
        variety,
        parentOrderId,
    });
    return response.data;
}

export async function cancelGttTrigger({ accountId, triggerId }) {
    const response = await axiosInstance.post('/api/trading-hub/gtt/cancel', {
        accountId,
        triggerId,
    });
    return response.data;
}
